export default (detailed) => ({
    detailed: Boolean(detailed),
    modalState: false,
    contentHeight: 0,
    truncateTextState: detailed ? false : true,
    videoModalState: false,
    trigger() {
        if (this.$store.responsive.isDesktop) {
            this.modalState = !this.modalState;
        } else {
            this.truncateTextState = !this.truncateTextState;
        }
    },
    openVideoModal() {
        this.videoModalState = true;
    },
    init() {
        if (!this.detailed) {
            this.$nextTick(() => {
                if (this.$refs.content) {
                    this.contentHeight = this.$refs.content.offsetHeight;
                    console.log(this.contentHeight);
                }
            });
        }
    }
})